import React, { Component } from 'react';
import StartPage from '../PAGES/StartPage';
import SizePage from '../PAGES/SizePage';
import GamePage from '../PAGES/GamePage';
import { START_PAGE, SIZE_PAGE, GAME_PAGE } from '../../HOME/const';
import { connect } from 'react-redux';
import { goToPage } from '../../HOME/REDUX/actions';

class TurboTiles extends Component {
  componentDidMount() {
    if (!this.props.page) {
      this.props.goToPage(START_PAGE);
    }
  }

  render() {
    const page = this.props.page || START_PAGE;

    return (
      <>
        {page === START_PAGE ? <StartPage /> : null}
        {page === SIZE_PAGE ? <SizePage /> : null}
        {page === GAME_PAGE ? <GamePage /> : null}
      </>
    );
  }
}

function mapStateToProps({ tt, common }) {
  return { ...tt, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage }
)(TurboTiles);
